import { AxiosResponse } from 'axios';
import jwtDecode from 'jwt-decode';
import { getLocalStorage } from '../utils/localstorage';
import axiosAPI from '../middlewares/axios-interceptor';


export function setToken(token: string | null, refreshToken: string | null) {
  if (token && refreshToken) {
    localStorage.setItem('access-token', token);
    localStorage.setItem('refresh-token', refreshToken);
    axiosAPI.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axiosAPI.defaults.headers.common.Authorization;
  }
}

function getHeaders() {
  const userDetails: any = getLocalStorage('userDetails');
  const { accessToken, refreshToken } = JSON.parse(userDetails);
  if (accessToken) {
    return {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'x-refresh': refreshToken,
        "Cache-Control": "no-cache, no-store, must-revalidate"
      },
    };
  }
  return undefined;
}

function getAdminHeaders() {
  const sessionAccessToken = sessionStorage.getItem('access-token');
  if (sessionAccessToken) {
    return {
      headers: {
        Authorization: `Bearer ${sessionAccessToken}`,
        "Cache-Control": "no-cache, no-store, must-revalidate"
      },
    };
  }
  return undefined;
}

const apiFunctions = {
  get: async (url: string): Promise<AxiosResponse['data']> => {
    return axiosAPI.get(url, getHeaders());
  },
  post: async (url: string, data: object): Promise<AxiosResponse['data']> => {
    return axiosAPI.post(url, data, getHeaders());
  },
  postpicture: async (
    url: string,
    data: object
  ): Promise<AxiosResponse['data']> => {
    return axiosAPI.post(url, data, getHeaders());
  },
  put: async (url: string, data: object): Promise<AxiosResponse['data']> => {
    return axiosAPI.put(url, data, getHeaders());
  },
  patch: async (url: string, data: object): Promise<AxiosResponse['data']> => {
    return axiosAPI.patch(url, data, getHeaders());
  },
  delete: async (url: string) => {
    return axiosAPI.delete(url, getHeaders());
  },
  getAdmin: async (url: string): Promise<AxiosResponse['data']> => {
    return axiosAPI.get(url, getAdminHeaders());
  },
  postAdmin: async (
    url: string,
    data: object
  ): Promise<AxiosResponse['data']> => {
    return axiosAPI.post(url, data, getAdminHeaders());
  },
  putAdmin: async (
    url: string,
    data: object
  ): Promise<AxiosResponse['data']> => {
    return axiosAPI.put(url, data, getAdminHeaders());
  },
  patchAdmin: async (
    url: string,
    data: object
  ): Promise<AxiosResponse['data']> => {
    return axiosAPI.patch(url, data, getAdminHeaders());
  },
  deleteAdmin: async (url: string) => {
    return axiosAPI.delete(url, getAdminHeaders());
  },
};

export function isTokenValid(token: string) {
  try {
    const decoded_jwt: any = jwtDecode(token);
    // const current_time = Date.now().valueOf() / 1000;
    // return decoded_jwt.exp > current_time;
    return decoded_jwt || false; // unlimited expiry
  } catch (error) {
    return false;
  }
}

// export default axios;
export default apiFunctions;